<template>
    <el-drawer title="配载" @close="closeDialog"  direction="ltr" size="50%"  :visible="peizaiFlag">
      <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="90px" size="mini">
      <div class="box">
        <el-form-item label="项目名称:" prop="projectType"   >
          <el-select  v-model="goodform.projectType" filterable placeholder="请选择">
            <el-option v-for="item in XMlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <div  style="display:flex;">
          <p style="margin-right:20px">结算客户：{{goodform.payee}}</p>
          <p style="margin-right:20px">业务类型：{{goodform.orderBusinessTypeName}}</p>
          <p>业务人员：{{goodform.businessUser}}</p>
        </div>
        <hr>
        <div v-for="(item,index) in rowDataList" :key="item.id"  style="padding:10px">
          <div  class="addressBox" >
            <h4 class="title">
              <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>收发货信息</span>
            </h4>
            <addDizhiSG :goodform="item" :isPeizai="index+1" @getLiuxiang="getLiuxiang" :key="index" ></addDizhiSG>
          </div>
          <div  class="addressBox" style="margin-top:20px">
            <h4 class="title">
              <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>货物信息</span>
            </h4>
          </div>
          <div class="box2" style="margin-top: -40px;">
            <p style=" margin-right: 40px;">合计：<span class="red">{{item.number}}</span>件/{{item.weight}}吨</p>
            <el-button type="primary" @click="qingkongFn(index)" >清空</el-button>
          </div>
          <el-table height="200px" size="mini" ref="tabref" :data="item.tGoodsInfo" style="width:100%" border center>
            <el-table-column type="index"  label="序号" width="60"></el-table-column>
            <el-table-column label="操作"  width="100">
              <template slot-scope="scope">
                <div>
                  <el-button type="text" size="mini" @click="delGoodFn(scope.$index,index)">删除</el-button>
                  <el-button type="text" size="mini"  @click="dapiaoFn(scope.row)">大票</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"
            width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)" align="center"
             width="200"></el-table-column>
             <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center"
             width="200"></el-table-column>
             <el-table-column :show-overflow-tooltip="true" prop="cargoLocation" label="货位" align="center"
             width="200"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="120"
            align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"
            width="200"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号" align="center"
            width="230"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号" align="center"
            width="200"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号" align="center"
            width="200"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="transportPlanNo" label="运输计划号" align="center"
              width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="unloadingSite" label="卸点" align="center"
            width="250"></el-table-column>
          </el-table>
          <div style="margin-top:20px" class="addressBox" >
            <h4 class="title">
              <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>结算信息</span>
            </h4>
          </div>
          <shouruSG :goodform="item"></shouruSG>
          <p style="padding:2px"></p>
          <hr>
        </div>
      </div>

      <el-drawer title="创建运单" size="98%" @close="closeDialog"   class="rightDrawer"
       :modal="false"  :visible="peizaiFlag">
       <div style="text-align: right;">合计：
              <span class="red">{{goodform.allWeight}}</span>吨/
              <span class="red">{{goodform.allNumber}}</span>件
        </div>

        <div  style="padding:12px">
          <!-- 车辆信息组件 -->
          <cheliangxinxi :goodform="goodform"></cheliangxinxi>
          <!-- 运费信息 -->
          <zhichu2 :goodform="goodform"></zhichu2>
        </div>
        <div class="footerBox">
          <el-button  @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="saveFn">提交</el-button>
          <el-button  type="primary"  @click="saveFn(3)">提交并打印</el-button>
        </div>
      </el-drawer>
      <el-dialog  title="大票" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="lookImgFlag"
        append-to-body width="800px" center>
        <div style="text-align: right;">
          <div id="printMe"  ref="print">
            <el-image style="width: 100%;" :src="imgUrl" fit="contain" :preview-src-list="[imgUrl]"></el-image>
          </div>
        </div>
      </el-dialog>
    </el-form>
  </el-drawer>

</template>

<script>
import cheliangxinxi from '@/views/newTMS/publicFiles/wayAndOrder/cheliangxinxi.vue'
import zhichu2 from '@/views/newTMS/publicFiles/wayAndOrder/zhichu2.vue'
import { addSgStowage, findCustomerInfoList, getDictionaryDetailList, getSgpzInfo } from '@/api/newTMS'
import addDizhiSG from '@/views/newTMS/publicFiles/wayAndOrder/addDizhiSG.vue'
import shouruSG from '@/views/newTMS/publicFiles/wayAndOrder/shouruSG.vue'
import { getInStockTicket } from '@/api/wms-access'
export default {
  name: 'zhipaiyouhuo',
  components: {
    cheliangxinxi, zhichu2, addDizhiSG, shouruSG
  },
  props: {
    peizaiFlag: {
      type: Boolean,
      default: false
    },
    dataList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      rowDataList: this.dataList,
      goodform: { allWeight: 0, measuringUnit: '吨' },
      lookImgFlag: false,
      imgUrl: '',
      rules: {
        projectType: [
          { required: true, message: '请选择项目名称', trigger: 'blur' }
        ],
        payer: [
          { required: true, message: '请输入车队长名称', trigger: 'blur' }
        ],
        payerTaxId: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        causeCancellation: [
          { required: true, message: '请输入作废原因', trigger: 'blur' }
        ],
        expenditurePattern: [
          { required: true, message: '请选择支出方式', trigger: 'blur' }
        ],
        freightPricingType: [
          { required: true, message: '请选择运费计价', trigger: 'blur' }
        ],
        freightUnitPrice: [
          { required: true, message: '请输入运费单价', trigger: 'blur' }
        ],
        allFreightAmount: [
          { required: true, message: '请输入运费金额', trigger: 'blur' }
        ],
        serviceRate: [
          { required: true, message: '请输入服务费率', trigger: 'blur' }
        ],
        serviceCharge: [
          { required: true, message: '请输入服务费', trigger: 'blur' }
        ],
        freightTaxRate: [
          { required: true, message: '请输入运费税率', trigger: 'blur' }
        ]
      },
      XMlist: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.rowDataList.forEach(item1 => {
      item1.xiedian = item1.tGoodsInfo[0].unloadingSite.replace(/\//g, '').replace(/-/g, '')
      item1.orderWeight = 0
      let allNumber = 0
      item1.tGoodsInfo.forEach(item => {
        item1.orderWeight = (item1.orderWeight * 1000 + item.weight * 1000) / 1000
        if (item.number) {
          allNumber = (allNumber * 1000 + item.number * 1000) / 1000
        }
      })
      this.$set(item1, 'weight', item1.orderWeight)
      this.$set(item1, 'number', allNumber)
    })
    this.$set(this.goodform, 'productType', this.rowDataList[0].productType)
    this.$set(this.goodform, 'productTypeName', this.rowDataList[0].productTypeName)

    findCustomerInfoList({
      pageNo: 1,
      businessType: 1,
      pageSize: 50,
      customerName: '首钢京唐钢铁联合有限责任公司'
    }).then(res => {
      this.$set(this.goodform, 'payee', '首钢京唐钢铁联合有限责任公司')
      if (res.list.length == 0) {
        this.$alert('“首钢京唐钢铁联合有限责任公司”没有维护，请维护该客户！', '系统提示')
      } else {
        this.goodform.payCustomerId = res.list[0].id
        this.goodform.payeeTaxId = res.list[0].customerTaxId
        this.goodform.periodDays = res.list[0].periodDays
        this.goodform.periodDaysType = res.list[0].periodDaysType
      }
    })
    getSgpzInfo().then(res => {
      this.$set(this.goodform, 'businessUnit', res.createDepartmentName)
      this.$set(this.goodform, 'businessUnitCode', res.createDepartmentCode)
      this.$set(this.goodform, 'businessSubunit', res.ext2)
      this.$set(this.goodform, 'businessSubunitCode', res.ext1)
      this.$set(this.goodform, 'businessTenantCode', res.tenantCode)
      this.$set(this.goodform, 'businessTenantName', res.tenantName)
      this.$set(this.goodform, 'businessSubCompanyName', res.createSubcompanyName)
      this.$set(this.goodform, 'businessSubCompanyCode', res.createSubcompanyCode)
      this.$set(this.goodform, 'businessUser', res.createUser)
      this.$set(this.goodform, 'businessUserId', res.createUserId)
      this.$set(this.goodform, 'businessPhone', res.ext3)
    }).catch(error => {
      this.$message({
        showClose: true,
        message: error.message,
        type: 'error',
        onClose () {
        }
      })
    })

    this.$set(this.goodform, 'orderBusinessTypeName', '配货外发业务')
    getDictionaryDetailList({ dictionaryType: 'business_type' }).then(res => {
      let yewuleixingJson = res.filter(item => item.showName == '配货外发业务')
      if (yewuleixingJson.length == 1) {
        this.$set(this.goodform, 'orderBusinessType', yewuleixingJson[0].itemNo)
      }
    })
    // this.$set(this.goodform, 'productTypeName', this.rowDataList[0].tGoodsInfo[0].productTypeName)
    // getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => {
    //   let hwlx = res.filter(item => item.showName == this.goodform.productTypeName)
    //   if (hwlx.length == 1) {
    //     this.$set(this.goodform, 'productType', hwlx[0].itemNo)
    //   }
    // })
    getDictionaryDetailList({ dictionaryType: 'project_type' }).then(res => { this.XMlist = res })
    this.getAllFn()
  },
  methods: {
    // 为了获取支出价格
    getLiuxiang (data) {
      console.log('getLiuxiang', data)
      if (data.type == '发货') {
        this.$set(this.goodform, 'startDirection', data.startDirection)
      }
      if (data.type == '收货') {
        this.$set(this.goodform, 'endDirection', data.endDirection)
      }
    },
    dapiaoFn (row) {
      const loading = this.$loading({
        lock: true,
        text: '正在加载...'
      })
      getInStockTicket({
        instockId: row.instockId
      }).then(res => {
        this.lookImgFlag = true
        this.lookimgList = []
        if (res !== null) {
          this.imgUrl = res.fileKeyUrl
        }
        loading.close()
      })
    },
    // 清空
    qingkongFn (index) {
      this.rowDataList.splice(index, 1)
      this.getAllFn()
    },
    // 删除货物
    delGoodFn (goodIndex, xuanIndex) {
      this.rowDataList[xuanIndex].tGoodsInfo.splice(goodIndex, 1)
      this.getAllFn()
      let num = 0
      let weight = 0
      this.rowDataList[xuanIndex].tGoodsInfo.forEach(item => {
        if (item.weight) {
          weight = (weight * 1000 + item.weight * 1000) / 1000
        }
        if (item.number) {
          num = (num * 1000 + item.number * 1000) / 1000
        }
      })
      this.rowDataList[xuanIndex].number = num
      this.rowDataList[xuanIndex].weight = weight
      if (this.rowDataList[xuanIndex].tGoodsInfo.length == 0) {
        this.rowDataList.splice(xuanIndex, 1)
      }
    },
    getAllFn () {
      let arr = []
      if (this.rowDataList.length != 0) {
        this.rowDataList.forEach(item => {
          arr = arr.concat(item.tGoodsInfo)
        })
      }
      this.goodform.allWeight = 0
      this.goodform.allNumber = 0
      arr.forEach(item => {
        if (item.weight) {
          this.goodform.allWeight = (this.goodform.allWeight * 1000 + item.weight * 1000) / 1000
        }
        if (item.number) {
          this.goodform.allNumber = (this.goodform.allNumber * 1000 + item.number * 1000) / 1000
        }
      })
    },
    // 保存
    saveFn (n) {
      if (!this.goodform.payCustomerId) {
        this.$alert('“首钢京唐钢铁联合有限责任公司”没有维护，请维护该客户！', '系统提示')
        return
      }
      let flag3 = this.rowDataList.every(item => item.kilometres)
      if (!flag3) {
        this.$alert('公里数不能为空，请联系系统管理员', '系统提示')
        return
      }
      let flag = this.rowDataList.every(item => item.shFlag)
      if (!flag) {
        this.$alert('没有匹配到收货地址，请重新选择', '系统提示')
        return
      }
      if (String(this.goodform.receivingAddress || '').includes('无地址')) {
        this.$alert('收货地址不能是“无地址”，请重新选择', '系统提示')
        return
      }
      let flag1 = this.rowDataList.every(item => item.incomeUnitPrice)
      if (!flag1) {
        this.$alert('请输入收入单价', '系统提示')
        return
      }
      let flag2 = this.rowDataList.every(item => item.incomeAmount)
      if (!flag2) {
        this.$alert('请输入收入金额', '系统提示')
        return
      }
      let flag4 = this.rowDataList.every(item => item.taxRate)
      if (!flag4) {
        this.$alert('请输入收入税率', '系统提示')
        return
      }

      if (this.goodform.transportMode == 1) {
        if (!this.goodform.driverName) {
          this.$alert('请选择司机', '系统提示')
          return false
        }
        if (!this.goodform.plateNumber) {
          this.$alert('请选择车辆', '系统提示')
          return false
        }
      }
      let flagDZ = this.rowDataList.every(item => this.rule.xingming.test(item.receivingPerson))
      if (!flagDZ) {
        this.$alert('联系人长度只支持2-20 个字符，必须为汉字。请修改后重新选择！', '系统提示')
        return
      }
      if (this.goodform.WHJKflag) {
        if (this.rowDataList.length > 1) {
          this.$alert('合单不能推送网货！', '系统提示')
          return false
        }
      }
      this.$refs.goodform.validate((valid) => {
        if (valid) {
          if (this.goodform.collectionType == 2) { // 司机
            this.$set(this.goodform, 'payer', this.goodform.driverName)
            this.$set(this.goodform, 'payerTaxId', this.goodform.idNumber)
          }
          this.goodform.sgStowageOrderList = this.rowDataList
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          addSgStowage(this.goodform).then(res => {
            loading.close()
            this.$emit('update:peizaiFlag', false)
            this.$parent.searchFn()
            if (n == 3) {
              this.$router.push({ path: '/tmsWayDayin', query: { ids: res } })
            }
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    closeDialog () {
      this.$emit('update:peizaiFlag', false)
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.box{
  padding:20px;
  font-size: 12px;
  .dingwei{
    position: absolute;
    right: 0px;
    top: -27px;
    width: 75px;
  }
}
.box1{
  display: flex;
  flex-wrap:wrap;
  p{
    margin-right: 20px;
    margin-top: 0;
  }
}
/deep/.el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin:14px 0 !important;
}
.width2  /deep/.el-input__inner{
    width: 100px;
}
.box2{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  p{
    margin-right: 20px;
    margin-top: 0;
  }
  /deep/.el-button {
    height: 30px;
  }
}
</style>
